import { Component, OnInit, Output, Injector, ViewChild } from '@angular/core';
import { Title } from '../../../../../shared/model';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Rx';
import { TitleService } from '../../../mesc.service';
import { MaintenanceService } from "../maintenance.service";
import { CgpSnackbarService } from '../../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpGridComponent } from '../../../../../shared/cgp-grid/cgp-grid.component';
import { CgpAlertDialogService } from '../../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';

@Component({
  selector: 'app-title',
  templateUrl: './title.component.html',
  // styleUrls: ['./title.component.scss']
})
export class TitleComponent implements OnInit {
  private readonly maintenanceService: MaintenanceService;
  @ViewChild(CgpGridComponent, { static: true }) grid: CgpGridComponent;
  constructor(
    private TitleService: TitleService,
    private readonly injector: Injector,
    private cgpSnackbarService: CgpSnackbarService,
    private cgpAlertDialogService: CgpAlertDialogService,
  ) {
    this.maintenanceService = injector.get(MaintenanceService);
    this.maintenanceService.getCurrentPageValue();
  }

  isNew: boolean = false;
  editDataItem: Title;
  editForm = new FormGroup({
    LidNumber: new FormControl("", Validators.required),
    Description: new FormControl("", Validators.required),
    CenterDescription: new FormControl(),
    Id: new FormControl(),
    CreatedDate: new FormControl(),
    CreatedBy: new FormControl(),
    ModifiedDate: new FormControl(),
    ModifiedBy: new FormControl(),
  });

  columns: any[] = [{
    field: "LidNumber",
    title: "LID #",
  }, {
    field: "Description",
    title: "Description",
  },
  ]
  
  onSave = (dataItem, isNew) => {
    var self = this;
    self.TitleService.save(dataItem, isNew, "", true, false)
      .then(function () {
        self.grid.refresh(true);
        self.cgpSnackbarService.showSnackbar({
          message: isNew ? "Record has been created" : "Record has been updated",
          duration: 2000
        });
      }).catch(function (response) {
        self.TitleService.loading.next(false);
        self.cgpAlertDialogService.showAlertDialog({
          title: 'Error',
          message: response._body.replace(/"/g, ''),
          alert: 'danger',
          closeLabel: 'Close',
        })
      });
  }

  onRead = () => {
    return this.TitleService.read('', true);
  }

  template = {
    controls: {
      add: true,
      edit: true,
      delete: true,
      excel: true,
    },
    columns: this.columns,
    service: this.TitleService,
    save: this.onSave,
    read: this.onRead,
    fileName: 'titles.xlsx'
  }


  formDialog = {
    title: "Title",
    formControls: [{
      type: "number",
      name: "LidNumber",
      title: "LID #*",
      readonly: "never",

    }, {
      type: "text",
      name: "Description",
      title: "Description*",
      readonly: "never",
    },
    ],
  }

 

  ngOnInit() {
    this.TitleService.query();
  }

  setModelHandler() {
    this.editDataItem = new Title();
  }

}
